import $ from "jquery";
import React from 'react';
import {
  Card,
  CardHeader,
  CardText
} from 'material-ui/Card';
import config from '../../config.json';
import auth from '../../auth/auth.react.js';
import DTable from './device_table.react.js';
import ConfirmDialog from '../../widgets/confirm_dialog.react.js';
import JSONInfoDialog from '../../widgets/json_info_dialog.react.js';
import UpdateDialog from './update_dialog.react.js';
import AliasDialog from './alias_dialog.react.js';
import CSSModules from 'react-css-modules';
import styles from './all.css';

const list_url = config.server + config.api_path + '/devices'
const connect_url = config.server + config.api_path + '/device/ssh/connect'
const disconnect_url = config.server + config.api_path +
  '/device/ssh/disconnect'
const update_url = config.server + config.api_path + '/service/update'
const alias_url = config.server + config.api_path + '/devices/alias'

class DeviceAllView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: props.title || 'Device under management'
    }

    this.load_data = this.load_data.bind(this)
    this.connect_device = this.connect_device.bind(this)
    this.open_update = this.open_update.bind(this)
    this.handle_device_update = this.handle_device_update.bind(this)
    this.open_connect = this.open_connect.bind(this)
    this.open_disconnect = this.open_disconnect.bind(this)
    this.open_delete = this.open_delete.bind(this)
    this.handle_disconnect = this.handle_disconnect.bind(this)
    this.handle_open_alias = this.handle_open_alias.bind(this)
    this.handle_open_info = this.handle_open_info.bind(this)
    this.handle_set_alias = this.handle_set_alias.bind(this)
    this.refresh_table = this.refresh_table.bind(this)
    this.delete_device = this.delete_device.bind(this)
  }

  refresh_table() {
    this.table.refresh()
  }

  load_data(rowsPerPage, offset, cb) {
    var filter_data = {}
    if (this.props.state_filter) {
      filter_data.state = this.props.state_filter
    }
    $.get({
        dataType: 'json',
        url: list_url,
        data: auth.with_session(filter_data, true),
        xhrFields: {
          withCredentials: true
        }
      })
      .done((data) => {
        var _err = data.err
        if (_err && _err.ec === 0) {
          cb(data.ret)
        } else if (_err && _err.ec === 403) {
          this.props.unauthorized()
        }
      })
  }

  delete_device(data, cb) {
    var self = this;
    $.post({
        dataType: 'json',
        url: list_url + '/' + data.id + '/destroy',
        data: auth.with_session({}),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          this.refresh_table()
          cb(null)
        } else if (_err && _err.ec === 403) {
          self.props.unauthorized()
        } else if (_err && _err.ec !== 0) {
          cb(new Error(_err.em))
        }
      })
  }

  connect_device(data, cb) {
    var self = this;
    $.post({
        dataType: 'json',
        url: connect_url,
        data: auth.with_session({
          deviceId: data.id
        }),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          this.refresh_table()
          cb(null)
        } else if (_err && _err.ec === 403) {
          self.props.unauthorized()
        } else if (_err && _err.ec !== 0) {
          cb(new Error(_err.em))
        }
      })
  }

  open_connect(device_data) {
    this.connect_dialog.open_confirm(device_data, device_data.alias, this.props
      .match.path)
  }

  open_delete(device_data) {
    this.delete_dialog.open_confirm(device_data, device_data.alias, this.props
      .match.path)
  }

  handle_disconnect(data, cb) {
    var self = this;
    $.post({
        dataType: 'json',
        url: disconnect_url,
        data: auth.with_session({
          deviceId: data.id
        }),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          this.refresh_table()
          cb(null)
        } else if (_err && _err.ec === 403) {
          self.props.unauthorized()
        } else if (_err && _err.ec !== 0) {
          cb(new Error(_err.em))
        }
      })
  }

  open_disconnect(device_data) {
    this.disconnect_dialog.open_confirm(device_data, device_data.alias,
      this.props
      .match.path)
  }

  open_update(device_data) {
    this.update_dialog.refs.component.open_update(device_data)
  }

  handle_device_update(data, cb) {
    const device = data.device_data
    const update_params = data.update
    var self = this;
    $.post({
        dataType: 'json',
        url: update_url,
        data: auth.with_session({
          deviceId: device.id,
          system: update_params.system,
          platform: update_params.platform,
          service: update_params.service,
          version: update_params.version
        }),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done(_data => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          self.refresh_table()
          cb(null)
        } else if (_err && _err.ec === 403) {
          self.props.unauthorized()
        } else if (_err && _err.ec !== 0) {
          cb(new Error(_err.em))
        }
      })
  }

  handle_open_alias(data) {
    this.alias_dialog.refs.component.handleClickOpen(data)
  }

  handle_set_alias(data, alias, cb) {
    var self = this;
    $.post({
        dataType: 'json',
        url: alias_url,
        data: auth.with_session({
          deviceId: data.id,
          alias: alias
        }),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done(_data => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          self.refresh_table()
          cb(null)
        } else if (_err && _err.ec === 403) {
          self.props.unauthorized()
        } else if (_err && _err.ec !== 0) {
          cb(new Error(_err.em))
        }
      })
  }

  handle_open_info(data) {
    return e => {
      this.info_dialog.open_info('Info for ' + data.alias, data.id)
    }
  }

  render() {
    return (
      <Card styleName="wrapper">
        <CardHeader
          title={this.state.title}
          actAsExpander={false}
          showExpandableButton={false}
        />
        <CardText styleName="dev-card">
          <ConfirmDialog
            prefix="Connect to"
            confirm_text="Connect"
            handle_confirm={this.connect_device}
            history={this.props.history}
            ref={(dialog) => {this.connect_dialog = dialog}}
          >
          </ConfirmDialog>
          <ConfirmDialog
            prefix="Disconnect from"
            confirm_text="Disconnect"
            handle_confirm={this.handle_disconnect}
            history={this.props.history}
            ref={(dialog) => {this.disconnect_dialog = dialog}}
          >
          </ConfirmDialog>
          <ConfirmDialog
            prefix="Delete device"
            confirm_text="Delete"
            handle_confirm={this.delete_device}
            history={this.props.history}
            ref={(dialog) => {this.delete_dialog = dialog}}
          >
          </ConfirmDialog>
          <UpdateDialog
            ref={(dialog) => {this.update_dialog = dialog}}
            confirm_update={this.handle_device_update}
            history={this.props.history}
          >
          </UpdateDialog>
          <AliasDialog
            ref={(dialog) => {this.alias_dialog = dialog}}
            onSubmitAlias={this.handle_set_alias}
          >
          </AliasDialog>
          <JSONInfoDialog
            ref={(d) => (this.info_dialog = d)}
            unauthorized={this.props.unauthorized}
          >
          </JSONInfoDialog>
          <DTable
            ref={(table) => {this.table = table}}
            load_devices={this.load_data}
            open_connect={this.open_connect}
            open_disconnect={this.open_disconnect}
            open_delete={this.open_delete}
            open_update={this.open_update}
            open_alias={this.handle_open_alias}
            open_info={this.handle_open_info}
            state_filter={this.props.state_filter}
          >
          </DTable>
        </CardText>
      </Card>
    )
  }
}

DeviceAllView.defaultProps = {
  data: [],
  state_filter: null,
  title: null,
  unauthorized: null
}

export default CSSModules(DeviceAllView, styles)



// WEBPACK FOOTER //
// ./src/views/devices/all.react.js